import { map } from "lodash";
import { TAG_OPERATIONS } from "src/consts/tags";
import { shouldHighlightTag } from "../utils/shouldHighlightTag";
import {
  TagsEditorTagBadge,
  type TagsEditorTagBadgeProps,
} from "../tagsEditorTagBadge";

export const renderExpandableTagBadges = ({
  visibleTags,
  onEntityTagClick,
  canNavigateToTag,
  onSelect,
  withAppliedCount,
  small,
  highlighted,
  entityType,
  shouldShowInfo,
  onInfo,
  inline,
}: {
  visibleTags: Array<{
    id?: unknown;
    status?: string;
    tagTypeConfig?: unknown;
    [key: string]: unknown;
  }>;
  onEntityTagClick?: unknown;
  canNavigateToTag: (tag: Record<string, unknown>) => boolean;
  onSelect: (tag: Record<string, unknown>) => (e: unknown) => void;
  withAppliedCount?: boolean;
  small?: boolean;
  highlighted?: boolean;
  entityType?: string | undefined;
  shouldShowInfo: (tag: Record<string, unknown>) => boolean;
  onInfo: (tag: Record<string, unknown>, config: unknown) => void;
  inline?: boolean;
}) =>
  map(visibleTags, (tag) => {
    const badgeProps: TagsEditorTagBadgeProps = {
      "data-testid": "cp-exp-badge-item",
      value: tag,
      withType: true,
      role: "listitem",
      isRemoved: tag.status === TAG_OPERATIONS.REMOVED,
      selected: canNavigateToTag(tag),
      disabled: !onEntityTagClick,
      ...(withAppliedCount !== undefined ? { withAppliedCount } : {}),
      ...(small !== undefined ? { small } : {}),
      highlighted: inline
        ? !!highlighted
        : shouldHighlightTag({
            tag: tag as Parameters<typeof shouldHighlightTag>[0]["tag"],
            entityType,
          } as Parameters<typeof shouldHighlightTag>[0]),
      ...(inline ? { mr: "3px", mt: "3px" } : {}),
      ...(canNavigateToTag(tag) ? { onSelect: onSelect(tag) } : {}),
      ...(shouldShowInfo(tag) ? { showInfo: true } : {}),
      onInfo: (e) => {
        (e as { stopPropagation: () => void }).stopPropagation();
        onInfo(tag, tag?.tagTypeConfig);
      },
    };

    return (
      <TagsEditorTagBadge
        key={
          tag.status === TAG_OPERATIONS.REMOVED
            ? `${String(tag.id)}_removed`
            : String(tag.id)
        }
        {...badgeProps}
      />
    );
  });
